const actions = {
  questionsName: 'SURVEY_QUESTIONS',
  questionTypesName: 'SURVEY_QUESTIONS_TYPES',
  requestQuestions: 'surveyQuestions/request',
  requestQuestionTypes: 'surveyQuestionTypes/request',
}

export default actions
